import React from 'react';
import ProjectList from "./ProjectList";
import "./project.css";

const Project = () => {

    const data = [
        {
            name:"MERN Stack Job Portal",
            des: "A MERN stack job portal is a modern and user-friendly online platform that brings together job seekers and employers. It leverages MongoDB to store job listings and user data, Express.js to handle server-side logic and API requests,.",
            projectlink:"https://geeksgod.com/",
            techused: [
                {
                    techname:"Node Js"
                },
                {
                    techname:"Express Js"
                },
                {
                    techname:"React Js"
                },
                {
                    techname:"Next Js"
                },
              
            ]
        },
        {
            name:"MERN Stack Social Media",
            des: "It is a long established fact that a reader will be distracted by the readable content of a page when look",
            projectlink:"https://geeksgod.com/",
            techused: [
                {
                    techname:"nodeJs"
                },
                {
                    techname:"Express Js"
                },
                {
                    techname:"Typescript"
                },
                {
                    techname:"Nuxt Js"
                },
              
            ]
        },
        {
            name:"MERN Stack Video Streaming",
            des: "It is a long established fact that a reader will be distracted by the readable content of a page when look",
            projectlink:"https://geeksgod.com/",
            techused: [
                {
                    techname:"Node Js"
                },
                {
                    techname:"Express Js"
                },
                {
                    techname:"React Js"
                },
                {
                    techname:"Angular Js"
                },
              
            ]
        },
        {
            name:"MERN Stack Online learning Streaming",
            des: "It is a long established fact that a reader will be distracted by the readable content of a page when look",
            projectlink:"https://geeksgod.com/",
            techused: [
                {
                    techname:"Node Js"
                },
                {
                    techname:"Express Js"
                },
                {
                    techname:"React Js"
                },
                {
                    techname:"Angular Js"
                },
              
            ]
        },
        {
            name:"MERN Stack E-commerce",
            des: "It is a long established fact that a reader will be distracted by the readable content of a page when look",
            projectlink:"https://geeksgod.com/",
            techused: [
                {
                    techname:"Node Js"
                },
                {
                    techname:"Express Js"
                },
                {
                    techname:"Material UI"
                },
                {
                    techname:"Redux"
                },
                {
                    techname:"React Js"
                },
              
            ]
        },
    ];
  return (
<div className='container' id="project">
 
<div className="section-title">
        <h5 className='title'>Projects</h5>
        <span className="line"></span>
    </div>
    <div className="row">

    {data.map((item, index) => (
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12" key={index}>
        <ProjectList {...item}/>


     </div>
     ))}
    </div>

</div>
    );
};

export default Project